export default __webpack_public_path__ + "static/media/img-2.e51ac9b7.jpg";